<script>
  import { onMount } from 'svelte';
  import { getForm, powerupForm } from '../../../services';
  import Accordion from './index.svelte';
  import EmailResponder from './powerups/configure/email-responder.svelte';
  import EmailTeamMember from './powerups/configure/email-team-member.svelte';

  export let open = false;
  export let form = null;

  let configureTeamEmail = false;
  let configureEmailResponder = true;
  let responseEmailEnabled;
  let teamEmailEnabled;
  let responseEmailSettings;
  let teamEmailSettings;

  $: responseEmailLabel = responseEmailEnabled ? 'Disable' : 'Enable';

  onMount(() => {
    if (form?.powerups) {
      responseEmailEnabled = (form?.powerups['webforma-email-responder'] || {})
        ?.active;
      responseEmailSettings = (form?.powerups['webforma-email-responder'] || {})
        ?.settings;
      teamEmailEnabled = (form?.powerups['webforma-team-email'] || {})?.active;
      teamEmailSettings = (form?.powerups['webforma-team-email'] || {})
        ?.settings;
    }
  });

  $: teamEmailLabel = teamEmailEnabled ? 'Disable' : 'Enable';

  function updateActiveStatus(powerupName) {
    return async (ev) => {
      await powerupForm({
        puid: powerupName,
        active: ev.target.checked,
        fid: form._id,
      });
      form = await getForm({ fid: form._id });
    };
  }
</script>

<Accordion title="Powerups" icon="battery-charging" {open}>
  <div slot="main">
    {#if form}
      <ul>
        <li class="title">Team Email</li>
        <li class="description">
          Send an email to a specified person on every form submission.
        </li>

        <EmailTeamMember
          active={teamEmailEnabled}
          settings={teamEmailSettings}
          {form}
          show={configureTeamEmail}
        />

        <li class="cta">
          <div>
            <input
              type="checkbox"
              role="switch"
              name="teamEmailEnabled"
              bind:checked={teamEmailEnabled}
              on:change={updateActiveStatus('webforma-team-email')}
            />
            {teamEmailLabel}
          </div>

          <div class="settings">
            <input
              type="checkbox"
              role="switch"
              bind:checked={configureTeamEmail}
            />
            Configure
          </div>
        </li>
      </ul>

      <ul>
        <li class="title">Response Email</li>
        <li class="description">
          Send an automatic response email to the person who filled out the
          form.
        </li>

        <EmailResponder
          active={responseEmailEnabled}
          settings={responseEmailSettings}
          {form}
          show={configureEmailResponder}
        />

        <li class="cta">
          <div>
            <input
              type="checkbox"
              role="switch"
              name="responseEmail"
              bind:checked={responseEmailEnabled}
              on:change={updateActiveStatus('webforma-email-responder')}
            />
            {responseEmailLabel}
          </div>

          <div class="settings">
            <input
              type="checkbox"
              role="switch"
              name="responseEmail"
              bind:checked={configureEmailResponder}
            />
            Configure
          </div>
        </li>
      </ul>
    {/if}
  </div>
</Accordion>

<style>
  :global(:root) {
    --sub-bg: #eee;
    --sub-highlight: #ccc;
  }
  :global([data-theme='dark']) {
    --sub-bg: rgba(0, 0, 0, 0.3);
    --sub-highlight: #222;
  }
  ul {
    background: var(--sub-bg);
    border-radius: 6px;
    --color: var(--contrast);
    margin: 0 1.2rem 1.2rem;
    padding: 2rem;
  }
  li {
    list-style-type: none;
  }
  li > div {
    padding: 1.2rem;
  }
  li.title {
    font-size: 1em;
    font-weight: 700;
    text-transform: uppercase;
  }
  li.description {
    border: solid thin var(--sub-highlight);
    padding: 1.2rem;
  }
  li.cta {
    background: var(--sub-bg);
    border: solid thin var(--sub-highlight);
    display: flex;
    gap: 2rem;
    margin-top: 2rem;
  }
</style>
